import APIUtils from '@spothero/utils/api';

const ReferralAPI = {
    add(requestData) {
        return APIUtils.post('refer/', requestData);
    },

    resend(emails) {
        return APIUtils.post('refer/resend/', {
            emails,
        });
    },

    getReferralStatuses() {
        return APIUtils.get('users/me/referral-statuses/');
    },

    checkReferralToken(token) {
        return APIUtils.get('refer/can-give-referral-credit/', {
            referral_token: token, // eslint-disable-line camelcase
        });
    },
};

export default ReferralAPI;
